import { HttpInterceptorFn } from '@angular/common/http';

/**
 * Interceptor to add a X-Correlation-ID header to every request.
 * Useful for distributed tracing and satisfying audit requirements.
 */
export const correlationInterceptor: HttpInterceptorFn = (req, next) => {
  const correlationId = crypto.randomUUID();

  // Add Correlation ID to the request headers
  const reqWithCorrelationId = req.clone({
    setHeaders: {
      'X-Correlation-Id': correlationId,
    },
  });

  return next(reqWithCorrelationId);
};
